module.exports = __webpack_public_path__ + "img/title.981f446a.png";